module.exports = __webpack_public_path__ + "r-v3/img/ml_100_00.e242916b.jpg";